// Compare two objects, partial deep equal
export function deepEqual(a, b) {
  // TODO - implement deep equal on view descriptors
  return Object.keys(a).some(function (key) {
    if (Array.isArray(a[key]) && Array.isArray(b[key])) {
      return deepEqual(a[key], b[key]);
    }

    return a[key] === b[key];
  });
}
//# sourceMappingURL=deep-equal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/utils/deep-equal.js
// module id = 394
// module chunks = 0